<template>
    <v-navigation-drawer v-model="inputValue" src="https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg" app color="grey darken-2" dark floating persistent width="260">
        <template v-slot:img="attrs">
            <v-img v-bind="attrs" gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"/>
        </template>

        <v-list-item two-line>
            <v-list-item-avatar color="white">
                <v-img src="https://cdn.vuetifyjs.com/images/logos/v.png" height="34" contain/>
            </v-list-item-avatar>

            <v-list-item-title class="title">問8</v-list-item-title>
        </v-list-item>

        <v-divider class="mx-3 mb-3" />

        <v-list v-for="(items, idx) in bar_items" :key="idx">
            <v-list-group v-if="check_includes(item.property)" v-for="item in items" :key="item.title" v-model="item.active" :prepend-icon="item.icon" no-action multiple>
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>
                </template>
                <template v-for="subItem in item.items" >
                    <v-list-item v-if="check_includes(subItem.property)" :key="subItem.title" :to="subItem.link">
                        <v-list-item-content >
                            <v-list-item-title v-text="subItem.title" ></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list-group>
        </v-list>
        <!-- <v-list-item v-if="check_type == 1" key="LINE Point設定" to="/line_point_setting">
            <v-list-item-content >
                <v-list-item-title v-text="'LINE Point設定'" ></v-list-item-title>
            </v-list-item-content>
        </v-list-item> -->
    </v-navigation-drawer>
</template>

<script>
import {
    mapMutations,
    mapState
} from 'vuex'

export default {
    props: {
        opened: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        // check_type: 1,
        check_type: parseInt(localStorage.getItem('account_type')),
        bar_items: [
            [
                {
                    icon: 'mdi-view-dashboard',
                    title: '帳號管理',
                    active: true,
                    items: [
                        { title: '帳號總覽', link: '/account_overview', property: [1, 2, 3]},
                        { title: '廠商總覽', link: '/vendor_overview', property: [1]},
                        { title: '醫師總覽', link: '/doctor_overview', property: [1, 2]},
                        { title: '病人總覽', link: '/patient_overview', property: [1, 2, 3]},
                    ],
                    property: [1, 2, 3]
                },
            ],
            [
                {
                    icon: 'mdi-view-dashboard',
                    title: '問卷管理',
                    active: true,
                    items: [
                        { title: '問卷總覽', link: '/question_overview', property: [1, 2, 3]},
                        // { title: '統計圖表', link: '/question_overview?m=2'},
                        { title: '統計圖表', link: '/statistics?m=2', property: [1, 2, 3]},
                        // { title: '交叉分析', link: '/question_overview?m=3'},
                        { title: '交叉分析', link: '/cross_analysis?m=3', property: [1, 2, 3]},
                    ],
                    property: [1, 2, 3]
                },
            ],
            [
                {
                    icon: 'mdi-view-dashboard',
                    title: '訊息頁面',
                    active: true,
                    items: [
                        { title: '一對一聊天', link: '/single_chat?url=https://account.line.biz/login?redirectUri=https%3A%2F%2Fmanager.line.biz%2F', property: [1, 2, 3]},
                        //{ title: '群發訊息', link: '/push_message', property: [1, 2, 3]},
                    ],
                    property: [1, 2, 3]
                },
            ],
            [
                {
                    icon: 'mdi-view-dashboard',
                    title: 'LINE Point設定',
                    active: true,
                    items: [
                        { title: '設定頁面', link: '/line_point_setting', property: [1]},
                    ],
                    property: [1]
                },
            ],

        ],
    }),

    computed: {
        inputValue: {
            get () {
                return this.$store.getters.drawer
            },
            set (val) {
                this.$store.commit('setDrawer', val)
            }
        },
    },

    methods: {
        check_includes(check_array){
            return check_array.includes(this.check_type)
        }
    }


}
</script>


<style lang="scss" scoped>

::v-deep .v-list-item__title{
    color: white;
}

</style>
